export var IncentivesSyncErrorCodes;
(function (IncentivesSyncErrorCodes) {
    // incentives to elt datasource (i.e table + column schema) sync errors
    IncentivesSyncErrorCodes["ConditionalCheckFailed"] = "dataSource.ConditionalCheckFailed";
    IncentivesSyncErrorCodes["UnknownColumnType"] = "dataSource.UnknownColumnType";
    IncentivesSyncErrorCodes["UnknownOperation"] = "dataSource.UnknownOperation";
    IncentivesSyncErrorCodes["OperationNotAllowed"] = "dataSource.OperationNotAllowed";
    IncentivesSyncErrorCodes["TableNotFound"] = "dataSource.TableNotFound";
    IncentivesSyncErrorCodes["ColumnNotFound"] = "dataSource.ColumnNotFound";
    IncentivesSyncErrorCodes["IncompatiblePicklistColumnType"] = "dataSource.IncompatiblePicklistColumnType";
    // incentives to elt calendar sync errors
    IncentivesSyncErrorCodes["CalendarConditionCheckFailed"] = "calendar.ConditionalCheckFailed";
    IncentivesSyncErrorCodes["CalendarNotFound"] = "calendar.CalendarNotFound";
    // incentives to elt permission sync errors
    IncentivesSyncErrorCodes["UnknownPermissionType"] = "permission.UnknownPermissionType";
})(IncentivesSyncErrorCodes || (IncentivesSyncErrorCodes = {}));
export const nonRetriableIncentivesSyncErrorCodes = [
    IncentivesSyncErrorCodes.ConditionalCheckFailed,
    IncentivesSyncErrorCodes.UnknownColumnType,
    IncentivesSyncErrorCodes.UnknownOperation,
    IncentivesSyncErrorCodes.OperationNotAllowed,
    IncentivesSyncErrorCodes.CalendarConditionCheckFailed,
    IncentivesSyncErrorCodes.UnknownPermissionType,
    IncentivesSyncErrorCodes.IncompatiblePicklistColumnType
];
//# sourceMappingURL=incentivesSyncErrorCodes.js.map